import urlApi from '../../router/urlApi'
import { Serialize } from '../../services/serializeFormData'
import { LoadFormData } from '../../services/LoadFormData'
import Vue from 'vue'
import Toast from 'vue-toasted'
import router from '../../router'

const toastOptions = {
  theme: 'none',
  position: 'bottom-center',
  className: 'vuestic-toast',
  iconPack: 'fontawesome',
  duration: 5000
}

Vue.use(Toast, toastOptions)
export default {

  store () {
    let self = this

    self.disableButtons(true)

    Vue.http.post(urlApi + '/aulas/salas', Serialize.toObject('form_sala')).then((response) => {
      if (response.status === 200) {
        self.launchToast('fa-check', response.data.mensagem)
        self.pageListarSalas()
      } else {
        self.launchToast('fa-check', 'Ops! não foi possivel realizar esta operação!')
      }
      self.disableButtons(false)
    }).catch((response) => {
      if (response.status === 422) {
        Object.keys(response.data.errors).forEach(function (key) {
          self.launchToast('fa-warning', response.data.errors[key][0])
        })
      } else {
        self.launchToast('fa-check', 'Ops! não foi possivel realizar esta operação!')
      }
      self.disableButtons(false)
    })
  },

  update (idSala) {
    let self = this
    self.disableButtons(true)
    Vue.http.patch(urlApi + '/aulas/salas/' + idSala, Serialize.toObject('form_sala')).then((response) => {
      if (response.status === 200) {
        self.launchToast('fa-check', response.data.mensagem)
        self.pageListarSalas()
      } else {
        self.launchToast('fa-check', 'Ops! não foi possivel realizar esta operação!')
      }
      self.disableButtons(false)
    }).catch((response) => {
      if (response.status === 422) {
        Object.keys(response.data.errors).forEach(function (key) {
          self.launchToast('fa-warning', response.data.errors[key][0])
        })
      } else {
        self.launchToast('fa-check', 'Ops! não foi possivel realizar esta operação!')
      }
      self.disableButtons(false)
    })
  },

  getSalaById: function (idSala, callback) {
    Vue.http.get(urlApi + '/aulas/salas/' + idSala).then(function (response) {
      callback(response)
    })
  },

  pageListarSalas () {
    router.push({ name: 'listagem-salas' })
  },

  paginaEdicao (idSala) {
    router.push({ name: 'editar-sala', params: { idSala: idSala } })
  },

  carregaFormularioDeEdicao (idContato) {
    Vue.http.get(urlApi + '/aulas/salas/' + idContato).then((response) => {
      LoadFormData.byIdInputs(response.data.dados)
    })
  },

  disableButtons (status) {
    document.getElementById('btn_salvar').disabled = status
    document.getElementById('btn_limpar').disabled = status
  },

  launchToast (icon, msg) {
    Vue.toasted.show(msg, {
      icon: icon,
      position: 'top-right',
      duration: 5000,
      fullWidth: false
    }
    )
  }

}
